var CurrentUser = require("lib/account/CurrentUser");
var DemoAccountSwitcher = require("lib/account/DemoAccountSwitcher");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');

require("layout/return_account_header.scss");

class ReturnAccountHeader extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	returnToAccount(e) {
		$wr.nope(e)
		window.wrNotifications.triggerDropDownNotification({
			title: "Switching back to account", text: "Just a few moments....", icon: "random" }, 10000);
		DemoAccountSwitcher.returnToAccount();		
	}

	logOut(e) {
		$wr.nope(e)
		CurrentUser.logOut();
		window.location = WhooosReadingServices.OuterPages.url("/");
	}

	render() {
		return (
			<div className="container returnAccountHeader">
				<div className="inner">
					<div className="leftSection">
						<img src={ require("owls/demo-student.png") } className="demoImg" />
						This is how Whooo's Reading looks for your students. Explore!
					</div>
					<div className="rightSection">
						<a href="#" onClick={ this.returnToAccount }>
							Return to Teacher Account
						</a><br />
						<a href="#" onClick={ this.logOut }>
							Log Out
						</a>
					</div>
				</div>
			</div>
		)
	}
};


ReturnAccountHeader.propTypes = StrictPropTypes({
});

module.exports = ReturnAccountHeader;



// WEBPACK FOOTER //
// ./modules/components/layout/ReturnAccountHeader.js